import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import PickerSelect from './PickerSelect';
import FormError from './FormError';
import FormLabel from './FormLabel';
import moment from 'moment';
import { CommonStyles } from '../styles';

export default function DateSelector({
  label,
  required,
  smallText,
  labelMonth,
  errorMessage,
  minDate,
  maxDate,
  onChangeDate = () => null,
  initialValue = '',
}) {
  const [date, setDate] = useState(initialValue ? moment(initialValue).format('MMM DD YYYY') : '');

  const generateDateRange = () => {
    const fromDate = moment(minDate);
    const toDate = moment(maxDate);
    const diff = toDate.diff(fromDate, 'days') + 1;
    const range = [];
    for (let i = 0; i < diff; i++) {
      range.push({
        label: moment(minDate).add(i, 'days').format('MMM DD YYYY'),
        value: moment(minDate).add(i, 'days').format('MMM DD YYYY'),
      });
    }
    return range;
  };

  function changeDate(newDate) {
    setDate(newDate);
    onChangeDate(new Date(newDate));
  }

  return (
    <View style={styles.container}>
      {!!label && <FormLabel label={label} required={required} smallText={smallText} />}
      <View style={styles.dateFormWrapper}>
        <PickerSelect
          items={generateDateRange()}
          value={date.toString()}
          style={CommonStyles.flex1}
          onValueChange={changeDate}
          placeholder={{ label: labelMonth ? labelMonth : 'Date' }}
        />
      </View>
      {!!errorMessage && <FormError errorMessage={errorMessage} />}
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    display: 'flex',
  },
  dateFormWrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
});
